import { useCallback, useEffect } from "react";
import { SidePanelDS, Spacer } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/hooks";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import "../../../../../i18n/i18n";
import { PublicEmspCdrs } from "../../transactionsAPI";
import { selectEmspCdrsList } from "../../transactionsSlice";
import { SidePanelHeader } from "./sidePanelHeader";
import { CdrDetails } from "./cdrDetails";
import { SidePanelSectionBlock } from "./sectionBlock";

export const EmspSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const firstPath = location.pathname.split("/")[1]; // home or departments

  const emspCdrsList: PublicEmspCdrs[] | null =
    useAppSelector(selectEmspCdrsList);

  const cdr = emspCdrsList?.find((t) => t.uuid === params.id);

  useEffect(() => {
    if (!cdr) {
      navigate(`/${firstPath}/transactions/emspCdrs`);
    }
  }, [firstPath, navigate, cdr]);

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/transactions/emspCdrs`);
  }, [firstPath, navigate]);

  if (!cdr) {
    return;
  }
  return (
    <SidePanelDS.SidePanel visible={!!cdr} onClose={onSidePanelClosed}>
      <SidePanelDS.Section
        verticalSpacing={1.5}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader cdr={cdr} />
        <Spacer y={1} />
        <SidePanelSectionBlock cdr={cdr} firstPath={firstPath} />
      </SidePanelDS.Section>
      <SidePanelDS.Section horizontalSpacing={1.5} verticalSpacing={2}>
        <CdrDetails cdr={cdr} />
      </SidePanelDS.Section>
    </SidePanelDS.SidePanel>
  );
};
